<template>
  <p v-if="!isLoading" class="mb-0 t-sm description pr-3"
    v-html="description"
    v-line-clamp="lineClamp"
  />
  <p class="pr-3 pb-0" v-else>
    <span class="pl_c--t pl_c--t pl_c--tfw d-block mt-2"></span>
    <span class="pl_c--t pl_c--t width--75per d-block mt-2"></span>
  </p>
</template>

<script>
export default {
  name: 'searchResultPartialDescription',
  props: {
    description: {
      type: String,
      required: true
    },
    lineClamp: {
      type: Number,
      default: 2
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
